import { createContext, useContext, useState, ReactNode, SetStateAction, Dispatch } from "react";
import { Group, UserInfo } from "../../../types";

type Location = {
  formattedAddress: string;
  lat: number;
  lng: number;
};

type CreateEventState = {
  eventName: string;
  descriptionRules: string;
  matchPrivacy: "PUBLIC" | "CLOSED";
  numberOfPlayers: [number, number];
  location: Location | null;
  date: Date;
  time: Date;
  duration: number;
  selectedEntities: UserInfo[];
  selectedGroups: Group[];
  formattedDateTime: string;
};

type CreateEventContextType = {
  state: CreateEventState;
  setState: Dispatch<SetStateAction<CreateEventState>>;
};

const CreateEventContext = createContext<CreateEventContextType | undefined>(undefined);

export const CreateEventProvider = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState<CreateEventState>({
    eventName: "",
    descriptionRules: "",
    matchPrivacy: "PUBLIC",
    numberOfPlayers: [8, 44],
    location: null,
    date: new Date(),
    time: new Date(),
    duration: 45,
    selectedEntities: [],
    selectedGroups: [],
    formattedDateTime: "",
  });

  return <CreateEventContext.Provider value={{ state, setState }}>{children}</CreateEventContext.Provider>;
};

export const useCreateEventContext = () => {
  const context = useContext(CreateEventContext);

  if (!context) {
    throw new Error("useCreateEventContext must be used within a CreateEventProvider");
  }

  return context;
};
